import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Warning, Login } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { closeErrorDialog } from '../../Reducer/ErrorDialogReducer';

/**
 * 전역 에러 다이얼로그 컴포넌트
 * Redux 상태를 사용하여 전역으로 ErrorDialog를 관리
 * 주로 401 인증 에러 등 특수한 경우에 사용
 */
function ErrorDialog() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { open, title, message, type, showLoginButton } = useSelector(
    (state) => state.errorDialog
  );

  const handleClose = () => {
    dispatch(closeErrorDialog());
  };

  const handleLogin = () => {
    // 인증 정보 초기화
    if (window.localStorage) {
      window.localStorage.setItem('auth', JSON.stringify({ auth: false }));
    }
    navigate('/');
    handleClose();
  };

  const getIconColor = () => {
    switch (type) {
      case 'auth':
        return '#ff9800';
      case 'warning':
        return '#ed6c02';
      case 'error':
      default:
        return '#d32f2f';
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <Warning sx={{ color: getIconColor(), fontSize: 28 }} />
          <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{ mt: 1, fontSize: '1rem', color: 'text.primary' }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {showLoginButton ? (
          <Button
            onClick={handleLogin}
            variant="contained"
            startIcon={<Login />}
            sx={{
              backgroundColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
            }}
          >
            로그인 화면으로 이동
          </Button>
        ) : (
          <Button onClick={handleClose} variant="contained" color="primary">
            확인
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default React.memo(ErrorDialog);
